import { render, staticRenderFns } from "./ApexChartFundRatio.vue?vue&type=template&id=64742ea9&"
import script from "./ApexChartFundRatio.vue?vue&type=script&lang=js&"
export * from "./ApexChartFundRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports